import { Helpers } from '../../helpers';
import { ICompletionsAreaTeam } from '../../interfaces/icompletions-area-team';
import { Area } from '../area';
import { Well } from '../well';

export class CompletionsAreaTeamBase {
  CompletionsAreaTeamId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Areas_CompletionsAreaTeam?: Array<Area> | null;
  Wells_CompletionsAreaTeam?: Array<Well> | null;

  constructor(item?: ICompletionsAreaTeam) {
    if (item) {

      this.CompletionsAreaTeamId = item.CompletionsAreaTeamId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Areas_CompletionsAreaTeam = Helpers.createClassArray(Area, item.Areas_CompletionsAreaTeam);
      this.Wells_CompletionsAreaTeam = Helpers.createClassArray(Well, item.Wells_CompletionsAreaTeam);
    }
  }
}